import React, { Suspense } from "react";
import Cookies from 'js-cookie';
import Loader from "../components/sharedUI/Loader/Loader";
import AuthGuard from "../AuthGuard";
import classes from "../routes/Landing.module.scss";
import AuditLogging from '../services/AuditLogging.Service';
import { funcGetPartnerData, getPartnerName, isNonbankaPartner } from "../shared/PartnerUtility";
export const StartIdleTimer = (cb) => {
    var IDLE_TIMEOUT = 600; //seconds
    var _idleSecondsTimer = null;
    var _idleSecondsCounter = 0;

    document.onclick = function () {
        _idleSecondsCounter = 0;
    };

    document.onmousemove = function () {
        _idleSecondsCounter = 0;
    };

    document.onkeypress = function () {
        _idleSecondsCounter = 0;
    };

    const CheckIdleTime = async () => {
        _idleSecondsCounter++;
        cb(IDLE_TIMEOUT, _idleSecondsCounter);
        if (_idleSecondsCounter >= IDLE_TIMEOUT) {
            window.clearInterval(_idleSecondsTimer);
            const partner = getPartnerName();
            if (partner && isNonbankaPartner(partner)) {
                const partnerUrl = await funcGetPartnerData(partner, "FatalError", "failure");
                localStorage.removeItem("partnerRedirect");
                window.location.href = partnerUrl;
            }
            else {
                if (partner) {
                    localStorage.removeItem("partnerRedirect");
                }
                const card = window.location.href.split("/").pop();
                document.location.href = `${window.location.origin}/${process.env.REACT_APP_NAME}/${card}`;
            }
        }
    }

    _idleSecondsTimer = window.setInterval(CheckIdleTime, 1000);

}
export const getCookieValue = () => {

    const cookieValue = Cookies.get("e-apply-data");
    //const cookieValue = "Vijay,,Kumar,9876543210,test@test.com,Mumbai";
    let personalInfo = null;
    if (cookieValue && cookieValue.length) {
        let cookieSplit = cookieValue.split(',');
        personalInfo = {
            ...personalInfo,
            firstName: cookieSplit[0],
            middleName: cookieSplit[1],
            lastName: cookieSplit[2],
            mobileNo: cookieSplit[3],
            emailId: cookieSplit[4],
            resiCity: cookieSplit[5],
            // isCookieData: true,
        }
    }
    return personalInfo;
};
export const geteApplyCookieValue = () => {
    const cookieValue = Cookies.get("e-apply-data");
    let cookieVal = null;
    if (cookieValue && cookieValue.length) {
        let cookieSplit = cookieValue.split(',');
        if (cookieSplit && cookieSplit.length) {
            cookieVal = { ...cookieVal, shortCode: cookieSplit[1] ? cookieSplit[1] : null, hsToken: cookieSplit[0] }
        }
    }
    return cookieVal;
};
export const deleteCookieValue = () => {
    Cookies.remove("e-apply-data");
}
export const GetPayLinkCookieValue = () => {
    const cookieValue = Cookies.get("penny_drop");
    let result = {};
    const applicationNumber = localStorage.getItem("applicationNumber");
    if (cookieValue !== undefined) {
        const cookieArray = cookieValue?.split("|");
        if (cookieArray?.length) {
            result = {
                "AuthStatus": cookieArray[1],
                "TxnReferenceNo": cookieArray[0]
            };
        }
    }
    else AuditLogging.sendLog('321', applicationNumber, "1", "Cookies valued not found");
    return result;
};



export const getSelectedCardDetails = (cardList, productType) => {
    const requiredCard = cardList.filter((card) => {
         return card.productType === productType;
    });
    return requiredCard[0];
}

export const getSelectedCardBannerDetails = (cardList, cardType) => {
    const requiredCard = cardList.filter((card) => {
        return card.cardType === cardType;
    });
    return requiredCard[0];
}

export const getCardDefaultNtwork = (cardList, cardType) => {
    const requiredCard = cardList.filter((card) => {
        return card.cardType === cardType;
    });
    return requiredCard.length && requiredCard[0].defaultNetwork ? requiredCard[0].defaultNetwork : "";
}
export const getCardProductType = (cardList, cardType) => {
    const requiredCard = cardList.filter((card) => {
        return card.cardType === cardType;
    });
    return requiredCard.length && requiredCard[0].productType ? requiredCard[0].productType : "";
}
export const getDateDifference = (startDate, endDate) => {
    var date1 = new Date(startDate);
    var date2 = new Date(endDate);
    var diffDays = parseInt((date2 - date1) / (1000 * 60 * 60 * 24), 10);
    return diffDays;
}

export const getCardTypeArray = () => {
      if (window.global.config?.FREQUENT_CARDS) {
        const cardTypeArray = window.global.config.FREQUENT_CARDS;
        return cardTypeArray;
      }
    // const cardTypeArray = ["MLCC", "LOTT", "LOTE", "LOTR", "LOTP", "AIEP", "AIES", "AILS", "AIPL", "AIPS", "AISS", "EAIP", "EAIS", "TATP", "TATS", "TCEA", "TCFP", "TECC", "TEP1", "TEP2", "TEP3", "TET1", "TET2", "TET3", "TPEA", "TPLT", "TSEA", "TTC1", "TTC2", "TTE1", "TTEC", "TTP1", "TTPE", "TTRE", "LOTS", "TATR", "TCPL", "TETC", "TPLC", "TSBP", "TTCD", "TTSB", "TTCV", "IRPT", "AISU", "IRRT", "IRCP", "PIRC", "IRCT", "IRWD", "TSPV", "TCPV", "TPCV", "TSTV", "TCTV", "AIPU", "DUM2"];
    // return cardTypeArray;
};

export const getFFMandatoryCards = () => {
    if (window.global.config?.FF_MANDATORY_CARDS) {
        return window.global.config.FF_MANDATORY_CARDS;
    }
};

export const isVerticalCard = (cardType) => {
      if (window.global.config?.VERTICAL_CARDS) {
        return window.global.config.VERTICAL_CARDS.indexOf(cardType) !== -1;
      }
    // return ["EGSU", "EGPU", "CSHB"].indexOf(cardType) !== -1
}
export const isFFNCard = (cardType) => {
    if (window.global.config?.FF_MANDATORY_CARDS) {
      return window.global.config.FF_MANDATORY_CARDS.indexOf(cardType) !== -1;
    }
}
export const isCVVFaceFrontCard = (cardType) => {
    if (window.global.config?.CVV_FACE_FRONT_CARDS) {
        return window.global.config.CVV_FACE_FRONT_CARDS.indexOf(cardType) !== -1;
    }
}
export const LoaderEle = () => (
    <div className={classes.loadingContainer}>
        <Loader />
    </div>
);

export const ComponentRoute = (Component, cardName, sepmobile = false) => {
    return (
        <Suspense fallback={LoaderEle}>
            <AuthGuard>
                <Component cardName={cardName} sepmobile={sepmobile} />
            </AuthGuard>
        </Suspense>
    );
}

export const SetTokenValues = (data, deleteFlag) => {
    if (data) {

        if (deleteFlag) {
            DeleteTokenCookie();
        };

        var expireTime = new Date().setTime(new Date().getTime() + (5 * 60 * 1000));
        Cookies.set("sprint-access-token", data?.accessToken, { expires: expireTime, secure: true });
        const cookievalue = data?.cookie.split("=");
        const cookieName = cookievalue[0];
        let cookieVal = data?.cookie.substring(data?.cookie.indexOf("=") + 1);
        Cookies.set(cookieName, cookieVal, { expires: expireTime, secure: true });
        Cookies.set("clientIPAddress", data?.clientIPAddress, { expires: expireTime, secure: true });
        localStorage.setItem("visitorID", data?.visitorId);
    }
}

// export const GetAccessToken = () => {
//     //const accessToken = Cookies.get("sprint-access-token");
//     const accessToken = localStorage.getItem("sprint-access-token");
//     if (accessToken && accessToken.length) {
//         return accessToken;
//     }
// }
export const DeleteTokenCookie = () => {
    Cookies.remove("sprint-access-token");
    Cookies.remove("x-sbic-user-fgp");
}
export const GetTokenCookie = () => {
    const sprintUser = Cookies.get("sprint-access-token");
    const clientIPAddress = Cookies.get("clientIPAddress");
    if (sprintUser && sprintUser.length && clientIPAddress && clientIPAddress.length) {
        return { accessToken: sprintUser, clientIPAddress: clientIPAddress };
    } else {
        return null;
    }
}
export const getC2BRetargetChannel = (retrieveRespnsegemId) => {
    /****Checked and Removed old channel values from the value coming from BE response****/
    if(retrieveRespnsegemId){
    const existingGemidValue = retrieveRespnsegemId.split(":");
    if(existingGemidValue.length===2){
    return existingGemidValue[1];
    }else{ 
    return (existingGemidValue[0].includes("C2B") || existingGemidValue[0].includes("c2b")) ?  "" : existingGemidValue[0];
    }
    }else{
        return retrieveRespnsegemId;
    }
}
export const getC2BChannel = (retrieveRespnsegemId) => {
    /****Checked and Removed old channel values from the value coming from BE response****/
    const existingGemidValue = retrieveRespnsegemId.split(":");
    return existingGemidValue[0];
}
export const getSelectedCardtypeNwDetails = (nwList, cardType) => {
    return nwList.filter( (card) => (card.cardType === cardType))?.[0];
}

export const getC2BGemid2Channel = (retrieveRespnsegemId) => {
    /****Checked and Removed old channel values from the value coming from BE response****/
    const existingGemidValue = retrieveRespnsegemId.split(":");
    if(existingGemidValue.length===2)
    return existingGemidValue[1];
    else
    return existingGemidValue[0];
}

export const getGemidId2ValueFromService = (retrieveRespnsegemId) => {
    /****Checked and Removed old channel values from the value coming from BE response****/
    if(retrieveRespnsegemId){
        const existingGemidValue = retrieveRespnsegemId.split(":");
        if(existingGemidValue.length===2){
            return existingGemidValue[0];
        }else{ 
            return (existingGemidValue[0].includes("C2B") || existingGemidValue[0].includes("c2b")) ?  "" : existingGemidValue[0];
        }
    }else{
        return retrieveRespnsegemId;
    }
}

// export const getGemid2LeadSource = (retrieveRespnsegemId,LeadSource) => {
//     /****Checked and Removed old channel values from the value coming from BE response****/
//     const existingGemidValue = retrieveRespnsegemId.split("_");
//     if (LeadSource!==existingGemidValue[0]) {
//         return LeadSource+"_"+retrieveRespnsegemId;
//     }else{
//         return retrieveRespnsegemId;
//     }
// }
// export const GetTokenPhrase = () => {
//     const sprintPass = localStorage.getItem("sprintPhrase");
//     if (sprintPass && sprintPass.length) {
//         return sprintPass;
//     }
// }